/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const AvatarXBadge16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <g clipPath="url(#prefix__AvatarXBadge16__a)" fill={vars.bdlGray}>
            <path d="M7.998 0c1.117 0 2.18.229 3.146.642-.28.22-.52.49-.707.795A7 7 0 1014.56 5.56c.305-.185.575-.425.795-.705A8 8 0 117.998 0z" />
            <path d="M7.998 9.5c1.21 0 2.293.413 3.232 1.096.56.407.953.817 1.168 1.104a.5.5 0 01-.8.6 3.316 3.316 0 00-.234-.267 5.408 5.408 0 00-.722-.629c-.78-.567-1.665-.904-2.644-.904-.98 0-1.865.337-2.644.904-.275.2-.517.415-.722.63-.083.084-.16.173-.234.266a.5.5 0 01-.8-.6c.215-.287.607-.697 1.168-1.104C5.705 9.913 6.788 9.5 7.998 9.5z" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.998 3.5a2.5 2.5 0 110 5 2.5 2.5 0 010-5zm0 1a1.5 1.5 0 100 3 1.5 1.5 0 000-3z"
            />
            <path d="M14.412 1.586a.5.5 0 00-.707 0l-.707.707-.707-.707a.5.5 0 00-.707.707L12.29 3l-.707.707a.5.5 0 00.707.707l.707-.707.707.707a.5.5 0 00.707-.707L13.705 3l.707-.707a.5.5 0 000-.707z" />
        </g>
        <defs>
            <clipPath id="prefix__AvatarXBadge16__a">
                <path fill="#fff" d="M0 0h16v16H0z" />
            </clipPath>
        </defs>
    </AccessibleSVG>
);

export default AvatarXBadge16;
